<template>
    <el-card shadow="never" class="aui-card--fill">

		<el-row style="background-color: #F3F4F4;">
				 <el-col :xs="24" :md="6" style="line-height: 40px;font-size: 16px;color: #121212;font-weight: bold;"><img style="width: 16px;height: 16px;margin-right: 12px;" src="../../../assets/img/user-list.png" />用户列表</el-col>

				 <el-col :xs="24" :md="18">
					<el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList()" style="text-align: right;">
						<el-form-item>
						  <el-button v-if="$hasPermission('user:userList:save')" class="addBtn" type="primary" @click="addOrUpdateHandle()">{{ $t('add') }}(企业用户)</el-button>
						</el-form-item>
							<el-form-item>
								<el-button v-if="$hasPermission('user:userList:export')"  @click="exportHandle()" class="exportBtn" type="default">{{ $t('export') }}</el-button>
							</el-form-item>
							<el-form-item>
								<el-button class="refreshBtn" type="default" @click="getDataList()">刷新</el-button>
							</el-form-item>
						<el-form-item>
						  <el-button v-if="$hasPermission('user:userList:delete')" class="delBtn" type="danger" @click="deleteHandle()">{{ $t('deleteBatch') }}</el-button>
						</el-form-item>
					</el-form>
				 </el-col>
		</el-row>

        <div class="mod-sys__user">
			<el-row style="border-bottom:3px solid #F3F4F4;padding-bottom: 10px;">
				<el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList()">
					<el-form-item style="margin-top: 20px;margin-left: 20px;" label="用户名称">
						<el-input v-model="dataForm.caName" placeholder="用户名称" clearable></el-input>
					</el-form-item>
					<el-form-item style="margin-top: 20px;margin-left: 20px;" >
						<el-button type="primary" @click="getDataList()">执行{{ $t('query') }}</el-button>
					</el-form-item>
				</el-form>
			</el-row>
            <el-table
                    v-loading="dataListLoading"
                    :data="dataList"
                    @selection-change="dataListSelectionChangeHandle"
                    @sort-change="dataListSortChangeHandle"
                    style="width: 100%;">
                <el-table-column type="selection" header-align="center" align="center" width="50"></el-table-column>
                <el-table-column prop="userCode" label="编码" header-align="center" align="center"></el-table-column>
                <el-table-column prop="userType" label="用户类型" header-align="center" align="center">
                    <template slot-scope="scope">
                        {{ $getDictLabel("userType", scope.row.userType) }}
                    </template>
                </el-table-column>
                <el-table-column prop="username" label="用户名称" header-align="center" align="center">
					<template slot-scope="scope">
					    <div v-if="scope.row.userType=='qyyh'">{{scope.row.caName==null?scope.row.username:scope.row.caName}}</div>
					    <div v-if="scope.row.userType=='gryh'">{{scope.row.realName}}</div>
					</template>
				</el-table-column>
                <el-table-column prop="simpleName" label="企业简称" header-align="center" align="center">
					<template slot-scope="scope">
						<div v-if="scope.row.userType=='qyyh'">{{scope.row.simpleName==null?scope.row.username:scope.row.simpleName}}</div>
					</template>
				</el-table-column>
                <el-table-column prop="mobile" label="手机号" header-align="center" align="center">
                </el-table-column>
                <el-table-column prop="createDate" label="操作日期" header-align="center" align="center">
                </el-table-column>
                <el-table-column prop="isEnable" :label="$t('user.status')" header-align="center" align="center">
                    <template slot-scope="scope">
                        <el-tag v-if="scope.row.isEnable === 0" size="small" type="danger">{{ $t('user.status0') }}
                        </el-tag>
                        <el-tag v-else size="small" type="success">{{ $t('user.status1') }}</el-tag>
                    </template>
                </el-table-column>
                <el-table-column :label="$t('handle')" fixed="right" header-align="center" align="center" width="200">
                    <template slot-scope="scope">
                        <el-button v-if="scope.row.isEnable === 0" type="text" size="small"
                                   @click="$hasPermission('user:userList:update') && enableOrDisableHandle(scope.row.id,1)">
                            启用
                        </el-button>
                        <el-button v-if="scope.row.isEnable === 1" type="text" size="small"
                                   @click="$hasPermission('user:userList:update') && enableOrDisableHandle(scope.row.id,0)">
                            停用
                        </el-button>
                        <el-button v-if="$hasPermission('user:userList:update') && scope.row.userType=='qyyh'" type="text" size="small"
                                   @click="addOrUpdateHandle(scope.row.id)">{{ $t('update') }}
                        </el-button>
						<el-button v-if="$hasPermission('user:userList:update') && scope.row.userType=='gryh'" type="text" size="small"
						           @click="grUpdateHandle(scope.row.id)">{{ $t('update') }}
						</el-button>
						<el-button v-if="scope.row.userType=='qyyh'" type="text" size="small"
						           @click="qychildHandle(scope.row.id,scope.row.status)">查看详情
						</el-button>
						<el-button v-if="scope.row.userType=='gryh'" type="text" size="small"
						           @click="grchildHandle(scope.row.id,scope.row.status)">查看详情
						</el-button>
						<!-- <el-button v-if="$hasPermission('user:userList:delete')" type="text" size="small" @click="deleteHandle(scope.row.id)">{{ $t('delete') }}</el-button> -->
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination
			background
                    :current-page="page"
                    :page-sizes="[10, 20, 50, 100]"
                    :page-size="limit"
                    :total="total"
                    layout="total, sizes, prev, pager, next, jumper"
                    @size-change="pageSizeChangeHandle"
                    @current-change="pageCurrentChangeHandle">
            </el-pagination>
            <!-- 弹窗, 新增 / 修改 -->
            <add-or-update v-if="addOrUpdateVisible" ref="addOrUpdate" @refreshDataList="getDataList"></add-or-update>
            <gr-update v-if="grUpdateVisible" ref="grUpdate" @refreshDataList="getDataList"></gr-update>
        </div>
    </el-card>
</template>

<script>
import mixinViewModule from '@/mixins/view-module'
import AddOrUpdate from './user-edit'
import GrUpdate from './gruser-edit'
import { addDynamicRoute } from '@/router'

import Cookies from 'js-cookie'
export default {
  mixins: [mixinViewModule],
  data () {
    return {
      grUpdateVisible: false,
      mixinViewModuleOptions: {
        // pageList
        getDataListURL: '/sys/user/page',
        getDataListIsPage: true,
        deleteURL: '/sys/user',
        deleteIsBatch: true,
        exportURL: '/sys/user/export'
      },

      jiesuan: [
        {
          value: 'qyyh',
          label: '企业用户'
        },
        {
          value: 'gryh',
          label: '个人用户'
        }
      ],
      role: Cookies.get('admin_role'),
      dataForm: {
        username: '',
        deptId: '',
        gender: '',
        userType: ''
      }
    }
  },
		  components: {
    AddOrUpdate,
    GrUpdate
		  },
  methods: {
    enableOrDisableHandle (id, isEnable) {
      this.$confirm('此操作将' + isEnable == 0 ? '将禁用' : '将启用' + '此条数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.handle(id, isEnable)
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消操作'
        })
      })
    },
    handle (id, isEnable) {
      this.$http.put('/sys/plat/info/ca', {
        id: id,
        status: isEnable
      }).then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        } else {
          this.$message({
            message: this.$t('prompt.success'),
            type: 'success',
            duration: 500,
            onClose: () => {
              this.query()
            }
          })
        }
      }).catch(() => {
      })
    },
    grUpdateHandle (id) {
      this.grUpdateVisible = true
      this.$nextTick(() => {
				  this.$refs.grUpdate.init()
				  this.$refs.grUpdate.dataForm.id = id
      })
    },
    grchildHandle (id, status) {
      console.log(this.$route.name)
      localStorage.setItem(this.$route.name,JSON.stringify(this.dataForm))
			  // 路由参数
			  const routeParams = {
        routeName: `${this.$route.name}__个人查看详情`,
        title: `个人查看详情`,
        path: 'user/edit-gryh-user',
        params: {
          id: id,
          status: status
        }
			  }
			  // 动态路由
			  addDynamicRoute(routeParams, this.$router)
    },
    qychildHandle (id, status) {
      console.log(this.$route.name)
      localStorage.setItem(this.$route.name,JSON.stringify(this.dataForm))
			  // 路由参数
			  const routeParams = {
        routeName: `${this.$route.name}__企业查看详情`,
        title: `企业查看详情`,
        path: 'user/edit-qyyh-user',
        params: {
          id: id,
          status: status
        }
			  }
			  // 动态路由
			  addDynamicRoute(routeParams, this.$router)
    },
    getvalue (e) {
      this.dataForm.userType = e
				  this.getDataList()
    }
  }
}
</script>
